/**
 * Payment Config (Admin PWA) - the restaurant's own payment settings: the same
 * screen as Back Office -> Payment Settings (terminals, checkout payment setup,
 * universal QR, batches), on this device's restaurant account.
 *
 * It used to call the company-admin door /api/admin/merchants/{id}/payment-config
 * with the restaurant's token (always 401) and fell back to restaurant 1.
 */
import React, { useMemo } from 'react';
import { useAccount, accountHeaders } from '@/lib/pwaAccount';
import PaymentSettingsPage from '@/pages/backoffice/PaymentSettingsPage';

export default function PaymentConfigurationPage() {
  const account = useAccount();
  const pageAccount = useMemo(() => {
    if (!account) return null;
    const { Authorization, ...headers } = accountHeaders(); // X-Merchant-ID for another location
    return { token: account.token, manager: { ...(account.manager || {}), restaurant_id: account.restaurant.id }, headers };
  }, [account]);
  if (!pageAccount) return null; // PwaAccountGate shows the sign-in
  // the customer display's settings live in Back Office -> Settings -> Display (not in this PWA)
  return <PaymentSettingsPage account={pageAccount} displaySettingsHref={false} />;
}
